import { render } from "./InternalTransfers.vue?vue&type=template&id=632557fa&ts=true"
import script from "./InternalTransfers.vue?vue&type=script&lang=ts"
export * from "./InternalTransfers.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__